// Pages that anyone with the link may open, with no session: the app must not call GET /me for
// them (docs/plan/09-security.md section 6, public routes). Matched on the address path.
const PUBLIC_PATHS: readonly RegExp[] = [
  /^\/q\/[^/]+\/?$/,
  // The link of a transmittal e-mail (GEDX-FE-02).
  /^\/t\/[^/]+\/?$/,
  // A share link to a document or a folder (GEDX-FE-03).
  /^\/l\/[^/]+\/?$/,
];

/** Whether `path` (an address path, with or without a query string) is a public page. */
export function isPublicPath(path: string): boolean {
  const pathname = path.split(/[?#]/)[0] ?? path;
  return PUBLIC_PATHS.some((pattern) => pattern.test(pathname));
}
